enum ConstituentSearchFilterField {
  NAME_EMAIL_PHONE = 'name_email_phone',
  USER_IDS = 'user_ids',
  HAS_ASSIGNEES = 'has_assignees',
  CONSTITUENT_CATEGORIES = 'constituent_categories',
  CONSTITUENT_RULES = 'constituent_rules', // This can be used interchangeably with constituent_categories. For consistency, favor using constituent_categories.
  CITY = 'city',
  STATE = 'state',
  POSTAL_CODE = 'postal_code',
  COUNTRY = 'country',
  CONSTITUENT_LABEL_IDS = 'constituent_label_ids',
  DONATION_LABEL_IDS = 'donation_label_ids',
  DONATION_TYPES = 'donation_types',
  DONATION_DATE = 'donation_date',
  DONATION_DATE_TYPE = 'donation_date_type',
  DONATION_LIFETIME_TOTAL_AMOUNT = 'donation_lifetime_total_amount',
  DONATION_LIFETIME_TOTAL_TIME = 'donation_lifetime_total_time',
  DONATION_THIS_YEAR_TOTAL_AMOUNT = 'donation_this_year_total_amount',
  DONATION_THIS_YEAR_TOTAL_TIME = 'donation_this_year_total_time',
  DONATION_LAST_YEAR_TOTAL_AMOUNT = 'donation_last_year_total_amount',
  DONATION_LAST_YEAR_TOTAL_TIME = 'donation_last_year_total_time',
  DONATION_MADE = 'donation_made',
  DONATION_PLAN_CADENCE = 'donation_plan_cadence',
  DONATION_AMOUNT = 'donation_amount',
  DONATION_MINUTES = 'donation_minutes',
  IS_DECEASED = 'is_deceased',
  IN_HONOR = 'donation_dedicated_to',
  CAMPAIGN_IDS = 'campaign_ids',
  BIRTHDAY_MONTH = 'birthday_month',
  DOB = 'dob',
  BOARD_IDS = 'board_ids',
  COLUMN_IDS = 'column_ids',
  CONNECTION_EMPLOYER_CONSTITUENT_IDS = 'connection_employer_constituent_ids',
  CONNECTION_HOUSEHOLD_CONSTITUENT_IDS = 'connection_household_constituent_ids',
  CONNECTION_CONSTITUENT_IDS = 'connection_constituent_ids', // Despite the name, the api is expecting a single value, not an array.
  CONSTITUENT_TYPE = 'constituent_type',
  IWAVE_AFFINITY_SCORE = 'iwave_affinity_score',
  IWAVE_CAPACITY_SCORE = 'iwave_capacity_score',
  IWAVE_PLANNED_GIVING_SCORE = 'iwave_planned_giving_score',
  IWAVE_PROPENSITY_SCORE = 'iwave_propensity_score',
  IWAVE_SCORE = 'iwave_score',
}

export default ConstituentSearchFilterField;
